module.exports = __webpack_public_path__ + "img/quartier.f8e49de5.jpg";